import { JobCompanyMessageResponse } from '@doda/api-client/aspida/@types';
import { Text } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';
import styles from './index.module.scss';

/**
 * MessageFromCompany
 */
interface Props {
  companyMessage: JobCompanyMessageResponse;
}

/**
 * 企業からのメッセージ
 * @property {string} listExclusiveHeading - 一覧専用見出し
 * @property {string} listExclusiveImage - 一覧専用画像
 * @property {string} listExclusiveSubHeading - 一覧専用サブ見出し
 * @property {string} listExclusiveMessage - 一覧専用メッセージ
 */
export const MessageFromCompany = ({
  companyMessage: {
    listExclusiveHeading,
    listExclusiveImage,
    listExclusiveSubHeading,
    listExclusiveMessage,
  },
}: Props) => {
  return (
    <SectionItem label="企業からのメッセージ">
      <div className={styles['jobSearchDetail-messageFromCompany']}>
        {listExclusiveImage && (
          <img
            className={styles['jobSearchDetail-messageFromCompany__image']}
            width={260}
            height={195}
            loading="lazy"
            alt=""
            src={listExclusiveImage}
          />
        )}
        <div className={styles['jobSearchDetail-messageFromCompany__message']}>
          <Text weight="bold">
            {listExclusiveHeading}
            {listExclusiveSubHeading && (
              <>
                <br />
                {listExclusiveSubHeading}
              </>
            )}
          </Text>
          {listExclusiveMessage && (
            <Text>
              <TextWithLF text={listExclusiveMessage} />
            </Text>
          )}
        </div>
      </div>
    </SectionItem>
  );
};
